import { MailAddressSuggest } from 'src/models/mail';

import { Callback } from 'src/util/query/models/Callback';

import { SetSuggestedMailAddressPayload } from '../interfaces';

export class GetTheMailAddressSuggestionsCallback extends Callback<MailAddressSuggest[]> {
	public constructor(
		private readonly aggregateId: string,
		private readonly setSuggestedMailAddress: (payload: SetSuggestedMailAddressPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: MailAddressSuggest[]): void => {
		this.setSuggestedMailAddress({
			aggregateId: this.aggregateId,
			suggestedMailAddress: successResponse,
		});
	};
}
